<template>
  <div class="container">
    <br />
    <br />
    <br />
    <h1 v-if="pending" class="text-center">UnSubscribing..</h1>
    <div v-else>
      <h3 class="text-center">
        Successfully removed <strong>{{ email }}</strong> from our mailing list.
      </h3>
      <p class="text-center">Thank you for being part of Dupaws.com</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      pending: true,
    };
  },
  mounted: function () {
    if (this.$router.currentRoute.query.email != null) {
      this.email = this.$router.currentRoute.query.email;
      this.unSubscribe(this.email);
    } else {
      alert("error unsubscribing...");
    }
  },
  methods: {
    unSubscribe: function (email) {
      var self = this;
      $.ajax({
        type: "POST",
        data: email,
        url:
          "https://www.dupaws.com/services/public/unSubscribe?email=" + email,
        dataType: "json",
        crossDomain: true,
        contentType: "application/json; charset=utf-8",
        success: function () {
          self.pending = false;
        },
        error: function (data, status, error) {
          self.errorMsg = data.responseJSON.Message;
        },
      });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// UnSubscribe.vue?3580f3fa